import { render } from "./Ratings.vue?vue&type=template&id=c9521fb6&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"

import "./Ratings.vue?vue&type=style&index=0&id=c9521fb6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9521fb6"]])

export default __exports__